module.exports = __webpack_public_path__ + "static/media/bg-full.cd43f5ea.png";